import { render } from "./MarkdownEditor.vue?vue&type=template&id=4bf24fce"
import script from "./MarkdownEditor.vue?vue&type=script&lang=js"
export * from "./MarkdownEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__